import React from 'react';
import { Drawer, Radio, RadioGroup, Stack } from 'rsuite';

export default function ActivityDrawer({ open, close,filterKeys,handlekeyChecked }) {
  return (
    <>
      <Drawer open={open} onClose={close}>
        <Drawer.Header>
          <Drawer.Title>My Activty</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
        <Stack direction="column" spacing={5} style={{ padding: '20px 0' }} alignItems='flex-start'>
              <RadioGroup
                name="radio-group"
                value={filterKeys}
                onChange={value => handlekeyChecked(value)}
              >
                <Radio name="querys" value="all">
                  <span
                    className={`roboto-regular myquerys ${filterKeys == 'all' && 'active'}`}
                  >
                    All Querys
                  </span>
                </Radio>
                <Radio name="querys" value="response">
                  <span
                    className={`roboto-regular myquerys ${
                      filterKeys == 'response' && 'active'
                    }`}
                  >
                    Response
                  </span>
                </Radio>
                <Radio name="querys" value="noreply">
                  <span
                    className={`roboto-regular myquerys ${
                      filterKeys == 'noreply' && 'active'
                    }`}
                  >
                    No Response
                  </span>
                </Radio>
                <Radio name="querys" value="opened">
                  <span
                    className={`roboto-regular myquerys ${
                      filterKeys == 'opened' && 'active'
                    }`}
                  >
                    Opened
                  </span>
                </Radio>
                <Radio name="querys" value="selected">
                  <span
                    className={`roboto-regular myquerys ${
                      filterKeys == 'selected' && 'active'
                    }`}
                  >
                    Selected
                  </span>
                </Radio>
              </RadioGroup>
            </Stack>
        </Drawer.Body>
      </Drawer>
    </>
  );
}
